import { EventEmitter } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
var CheckboxComponent = /** @class */ (function () {
    function CheckboxComponent() {
        this.ngModelChange = new EventEmitter();
    }
    Object.defineProperty(CheckboxComponent.prototype, "disabled", {
        set: function (flag) { this.isDisabled = flag; },
        enumerable: true,
        configurable: true
    });
    ;
    CheckboxComponent.prototype.onClick = function () {
        if (this.isDisabled || this.noChanges)
            return;
        this.model = !this.model;
        this.changeHandler(this.model);
    };
    CheckboxComponent.prototype.ngOnInit = function () {
        this.isDisabled = this.disabled;
    };
    CheckboxComponent.prototype.writeValue = function (checked) {
        this.model = checked;
    };
    CheckboxComponent.prototype.registerOnChange = function (fn) {
        this.changeHandler = fn;
    };
    CheckboxComponent.prototype.registerOnTouched = function (fn) {
        this.touchedHandler = fn;
    };
    CheckboxComponent.prototype.setDisabledState = function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    return CheckboxComponent;
}());
export { CheckboxComponent };
